/* ============================================================================
   VV MOBILE PRODUCT-CARD SWIPE CAROUSEL
   Syncs the active dot with the swiped image, and lets dots be tapped to jump.
   Swiping itself is native CSS scroll-snap — this file adds no swipe logic.
   Mobile only (<700px); on desktop every handler early-returns, so it is inert.
   One delegated listener each for scroll/click — scales to any number of cards.
   See snippets/UPGRADE-CUSTOM-CALLS.liquid item 28.
   ============================================================================ */
(function () {
  var mobile = window.matchMedia('(max-width: 699px)');

  function rafThrottle(fn) {
    var ticking = false;
    return function (event) {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        fn(event);
      });
    };
  }

  function dotsFor(track) {
    var carousel = track.closest('.product-card__mobile-carousel');
    return carousel ? carousel.querySelectorAll('.product-card__dots > *') : [];
  }

  function syncDots(event) {
    if (!mobile.matches) return;
    var track = event.target;
    if (!track.classList || !track.classList.contains('product-card__track')) return;

    var dots = dotsFor(track);
    if (!dots.length || !track.clientWidth) return;

    var index = Math.round(track.scrollLeft / track.clientWidth);
    if (index < 0) index = 0;
    if (index > dots.length - 1) index = dots.length - 1;

    for (var i = 0; i < dots.length; i++) {
      dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
    }
  }

  // 'scroll' does not bubble, so listen in the capture phase.
  document.addEventListener('scroll', rafThrottle(syncDots), true);

  // Tap a dot to jump to that image.
  document.addEventListener('click', function (event) {
    var dot = event.target.closest && event.target.closest('.product-card__dots > *');
    if (!dot) return;

    var carousel = dot.closest('.product-card__mobile-carousel');
    var track = carousel && carousel.querySelector('.product-card__track');
    if (!track) return;

    event.preventDefault();
    var index = parseInt(dot.getAttribute('data-index') || '0', 10);
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  });
})();
